/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;
exports.getAuthor = getAuthor;
exports.getSection = getSection;
exports.checkAspectRatio = checkAspectRatio;

var _lodashFind = require('lodash/find');

var _lodashFind2 = _interopRequireDefault(_lodashFind);

var _lodashRound = require('lodash/round');

var _lodashRound2 = _interopRequireDefault(_lodashRound);

/**
 * Find author based on collection and ID
 * @param  {number} id
 * @param  {array}  authors
 */

function getAuthor(id, authors) {
  var author = _lodashFind2['default'](authors, { 'id': id });

  return author || false;
}

/**
 * Find section based on collection and ID
 * @param  {number} id
 * @param  {array}  categories
 */

function getSection(categories) {
  var section = _lodashFind2['default'](categories, { 'parent': 24 });

  return section || false;
}

/**
 * Check the aspect ratio of an image
 * @param  {number} width
 * @param  {number} height
 */

function checkAspectRatio(width, height) {
  return _lodashRound2['default'](width / height, 2) === 1.78;
}
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/index.js
 ** module id = 723
 ** module chunks = 0
 **/